export default "__VITE_ASSET__215aa545__"